/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicantCreatePayloadRequest
 */
export interface ApplicantCreatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicantCreatePayloadRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantCreatePayloadRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantCreatePayloadRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ApplicantCreatePayloadRequest interface.
 */
export function instanceOfApplicantCreatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ApplicantCreatePayloadRequestFromJSON(json: any): ApplicantCreatePayloadRequest {
    return ApplicantCreatePayloadRequestFromJSONTyped(json, false);
}

export function ApplicantCreatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicantCreatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
    };
}

export function ApplicantCreatePayloadRequestToJSON(value?: ApplicantCreatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
    };
}

